import React from "react";
import AppErrorFallback from "@/components/AppErrorFallback";

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(_error: Error, _errorInfo: React.ErrorInfo) {
    // You can log the error to an error reporting service here
    // console.error(_error, _errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <AppErrorFallback
          title="Something went wrong."
          description="Sorry, an unexpected error occurred. Please refresh the page to continue."
          actionLabel="Refresh page"
          error={this.state.error}
          onAction={() => window.location.reload()}
        />
      );
    }
    return this.props.children;
  }
}
